import React, { FC, useContext, useEffect, useState } from "react";
import LocalizationContext from "../../../Localization/LanguageContext";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import DataContext from "../../../Context";
import { IPolicy } from "../../../Models/PolicyInfo";
import FormRow from "../../FormRow";
import Label from "../../Label";
import TextInput from "../../TextInput";

interface Props {
  id: string;
  answer: string;
  setAnswer: React.Dispatch<React.SetStateAction<string>>;
  isRequired: boolean;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
}



const Answer: FC<Props> = ({
  id,
  answer,
  setAnswer,
  isRequired,
  setIsRequired,
}) => {
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  const [isValid, setIsValid] = useState(false);

  const {
    isSanitized
  } = useContext(DataContext) as IPolicy;

  useEffect(() => {
    if (answer.trim()) setIsValid(true);
    else if (isRequired) setIsValid(false);
    else setIsValid(true);
  }, [isRequired, answer]);

  return (
    <FormRow>
      <Label>{getValue('SecurityQuestions', 'Answer')}</Label>
      <TextInput
        inputId={id}
        inputValue={answer}
        isInvalid={!isValid || !isSanitized(answer)}
        onChange={(e) => setAnswer(e.target.value)}
        onBlur={() => setIsRequired(true)}
        onFocus={() => setIsRequired(false)}
        errorMessage={getValue('SecurityQuestions','ValAnswer')}
      />
    </FormRow>
  );
};

export default Answer;
